import api from '../api';

/** ID aceito em `PUT /website/{id}` (Long): número ou string só com dígitos. */
function isNumericWebsiteId(v) {
    if (v === undefined || v === null || v === '') return false;
    if (typeof v === 'number' && Number.isFinite(v)) return true;
    return /^\d+$/.test(String(v).trim());
}

function toNumericWebsiteId(v) {
    if (typeof v === 'number' && Number.isFinite(v)) return v;
    return parseInt(String(v).trim(), 10);
}

/** Integer/Long em JSON: número ou string só com dígitos (empresa, etc.). */
function isNumericEntityId(v) {
    if (v === undefined || v === null || v === '') return false;
    if (typeof v === 'number' && Number.isFinite(v)) return true;
    return /^\d+$/.test(String(v).trim());
}

function toIntId(v) {
    if (typeof v === 'number' && Number.isFinite(v)) return v;
    return parseInt(String(v).trim(), 10);
}

/**
 * `company.id` deve ser Integer no servidor. Nanoid no payload quebra o parse;
 * remover só o id gera NPE (getId() null). Usamos o `GET /website` (`fresh`)
 * para repor o id numérico quando existir.
 */
function sanitizeWebsitePutPayload(payload, fresh) {
    if (!payload || typeof payload !== 'object') return payload;
    const out = { ...payload };

    if (!out.company || typeof out.company !== 'object') {
        return out;
    }

    const c = { ...out.company };
    const idPayload = c.id;
    const idFresh = fresh && fresh.company ? fresh.company.id : undefined;

    let resolved = null;
    if (isNumericEntityId(idPayload)) {
        resolved = toIntId(idPayload);
    } else if (isNumericEntityId(idFresh)) {
        resolved = toIntId(idFresh);
    }

    if (resolved !== null) {
        c.id = resolved;
        out.company = c;
    } else {
        delete out.company;
    }

    return out;
}

export default {
    async getWebsite(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get('/website', {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do website:', error);
            throw error;
        }
    },

    /**
     * Atualiza o website: `PUT /website/{idLong}` com corpo JSON.
     * O store (login) pode trazer `id` como string nanoid; nesse caso busca
     * `GET /website` e usa o `id` numérico retornado pela API.
     */
    async editWebsite(accessToken, id, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            let resolved =
                id !== undefined && id !== null && id !== ''
                    ? id
                    : payload?.id;

            let fresh = null;
            if (!isNumericWebsiteId(resolved)) {
                fresh = await this.getWebsite(accessToken);
                resolved = fresh?.id;
            }

            if (!isNumericWebsiteId(resolved)) {
                throw new Error(
                    'ID numérico do website não encontrado para PUT /website/{id}.'
                );
            }

            const idLong = toNumericWebsiteId(resolved);

            if (!fresh) {
                fresh = await this.getWebsite(accessToken);
            }

            const body = sanitizeWebsitePutPayload(
                { ...payload, id: idLong },
                fresh
            );
            const response = await api.put(`/website/${idLong}`, body, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar dados do website:', error);
            throw error;
        }
    },
    
    async createWebsite(accessToken, payload){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/website', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao criar website:', error);
            throw error;
        }
    },
    async verifyDomaintData( accessToken, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/manager/checkdomain`, payload , {
                method: 'POST',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao verificar url de dominio', error);
                throw error;
        }
    },
    async clearCache( accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.delete(`/manager/cache/clear`, {
                method: 'DELETE',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao limpar cache', error);
                throw error;
        }
    },
}
